import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { z } from 'zod/v4';

import { canDuplicateContracts, CONTRACTS_MANAGE_PERMISSION, LEASING_CONTRACTS_PATH } from '&/features/leasing/paths';

/** SWOOP-397: `?duplicateFrom=<contractId>` prefills the wizard from that master contract. Absent = a blank new contract. */
const newContractSearchSchema = z.object({ duplicateFrom: z.string().optional() });

// SWOOP-322. The trailing underscore un-nests it from `contracts.tsx`, which has no <Outlet/> (precedent:
// `vehicles_.add.tsx`). The parent `/leasing` route applies the module switch and `leasing:access`; this one
// adds `contracts:manage` — or, when `?duplicateFrom` is set (SWOOP-397), BOTH `contracts:manage` and the
// dedicated `contract-duplicates:manage` the Duplicate action needs. On a hard refresh permissions may not be
// loaded yet, so `beforeLoad` lets that through and the page checks again once they are.
export const Route = createFileRoute('/_authenticated/leasing/contracts_/new')({
  beforeLoad: ({ context, search }): void => {
    if (!context.permissions.isReady) {
      return;
    }
    const allowed =
      search.duplicateFrom !== undefined
        ? canDuplicateContracts(context.permissions.hasPermission)
        : context.permissions.hasPermission(CONTRACTS_MANAGE_PERMISSION);
    if (!allowed) {
      throw redirect({ to: LEASING_CONTRACTS_PATH });
    }
  },
  component: lazyRouteComponent(() => import('&/features/leasing/pages/new-contract-page')),
  staticData: { titleKey: 'leasingNewContract' },
  validateSearch: newContractSearchSchema,
});
